import React from 'react';
import Image from '@gerenciatd/next.components.image-n';
import TextInfo from '@gerenciatd/next.components.text-info-n';
import Price from '@gerenciatd/next.components.price';
import CustomLink from '@gerenciatd/next.components.custom-link';


const DeviceCard = (props) => { 
  const { custoObjectInfo } = props;
  //Making posible editable
  let textInfoCustoObjectInfo1 = null;
  let textInfoCustoObjectInfo2 = null;
  let textInfoCustoObjectInfo3 = null;
  let imageInfoCustoObject1 = null;
  if (custoObjectInfo){
    textInfoCustoObjectInfo1 = custoObjectInfo.addEntryPoint({
      custoObjectInfo: custoObjectInfo,
      entryPoint: 'TextInfo-1'
    })
    textInfoCustoObjectInfo3 = custoObjectInfo.addEntryPoint({
      custoObjectInfo: props.custoObjectInfo,
      entryPoint: 'TextInfo-2'
    })
    textInfoCustoObjectInfo3 = custoObjectInfo.addEntryPoint({
      custoObjectInfo: props.custoObjectInfo,
      entryPoint: 'TextInfo-3'
    })
    imageInfoCustoObject1 = custoObjectInfo.addEntryPoint({
      custoObjectInfo: props.custoObjectInfo,
      entryPoint: 'Image-1'
    })
  }

  return (
    <>
      <div className="DeviceCard">
        <div className="picture-gap">
          {props['Image-1'] && (
            <Image
              {...props['Image-1']}
              layout="fill"
              objectFit="center"
              custoObjectInfo={imageInfoCustoObject1}
            />)}
        </div>
        <div className="info-content">
          {props['TextInfo-1'] && (
            <div className="textGap">
              <TextInfo {...props['TextInfo-1']} custoObjectInfo={textInfoCustoObjectInfo1} />
            </div>
          )}
          {props['TextInfo-2'] && (
            <div className="textGap">
              <TextInfo {...props['TextInfo-2']} custoObjectInfo={textInfoCustoObjectInfo2} />
            </div> 
          )}
          {props['TextInfo-3'] && (
            <div className="textGap">
              <TextInfo {...props['TextInfo-3']} custoObjectInfo={textInfoCustoObjectInfo3} />
            </div> 
          )}
          {props['Price-1'] && (
            <Price {...props['Price-1']} />
          )}
          {props['Price-2'] && (
            <Price {...props['Price-2']} />
          )}
          {!props.custoObjectInfo && props['CustomLink-1'] && (
            <CustomLink {...props['CustomLink-1']} />
          )}
        </div>
      </div>
      <style jsx>
      {`
        .DeviceCard {
          position:relative;
          max-width: 288px;
          overflow:hidden;
          height: 100%;
          display:block;
          margin: 0 auto;
          border:1px solid #ddd;
          border-radius: 8px;
          display: flex;
          flex-direction: column;

          .picture-gap {
            position:relative;
            height: 185px;
            width: 100%;
          }
          .info-content {
            padding:0.5rem;
            background-color:white;
            .textGap{
              margin-bottom:1rem;
            }
          }
        }
        @media screen and (max-width: 900px){
          .DeviceCard{
            width: 50%;
            
            min-width: 250px;
          }
        }
      `}
      </style>
    </>
  )

}

export default DeviceCard;